function createAction(type, meta) {
  return function (payload) {
    return { type, payload, meta };
  };
}

export default createAction;
